import {
  LEDGER_REPORT_REQUEST,
  LEDGER_REPORT_FAILURE,
  SET_LEDGER_PARTIES,
  SET_LEDGER_BY_PARTY,
  SET_TRIAL_BALANCE_SCHEDULE_PARTIES,
  SET_TRADING_ACCOUNT_PARTIES,
  SET_PROFIT_LOSS_ACCOUNT,
  SET_BALANCE_SHEET,
  LEDGER_BY_PARTY_REPORT_REQUEST,
  LEDGER_BY_PARTY_REPORT_FAILURE,
  SET_LEDGER_BY_SCHEDULE,
  LEDGER_REPORT_SCHEDULE_REQUEST,
  LEDGER_REPORT_REQUEST_FAILURE,
  LEDGER_REPORT_REQUEST_SUCCESS
} from "../types/ledger-report-types";

const initialState = {
  ledgerParties: [],
  trialBalScheduleParties: [],
  tradingAccount: {},
  profitLossAccount: {},
  balanceSheet: {},
  ledgerByParty: {},
  ledgerBySchedule: [],
  loading: false,
  error: null,
};

const ledgerReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LEDGER_REPORT_REQUEST: {
      return {
        ...state,
        ledgerParties: [],
        trialBalScheduleParties: [],
        tradingAccount: {},
        profitLossAccount: {},
        balanceSheet: {},
        ledgerBySchedule: [],
        loading: true,
        error: null
      };
    }
    case LEDGER_REPORT_SCHEDULE_REQUEST: {
      return {
        ...state,
        ledgerBySchedule: [],
        loading: true,
        error: null
      };
    }
    case LEDGER_BY_PARTY_REPORT_REQUEST: {
      return {
        ...state,
        // ledgerByParty: {},
        loading: true,
        error: null
      };
    }
    case SET_LEDGER_PARTIES: {
        return {
          ...state,
          ledgerParties: action.payload || [],
          loading: false,
          error: null
        };
    }
    case SET_TRIAL_BALANCE_SCHEDULE_PARTIES: {
      return {
        ...state,
        trialBalScheduleParties: action.payload || [],
        loading: false,
        error: null
      };
    }
    case SET_TRADING_ACCOUNT_PARTIES: {
      return {
        ...state,
        tradingAccount: action.payload || [],
        loading: false,
        error: null
      };
    }
    case SET_PROFIT_LOSS_ACCOUNT: {
      return {
        ...state,
        profitLossAccount: action.payload || [],
        loading: false,
        error: null
      };
    }
    case SET_BALANCE_SHEET: {
      return {
        ...state,
        balanceSheet: action.payload || [],
        loading: false,
        error: null
      };
    }
    case SET_LEDGER_BY_PARTY: {
      return {
        ...state,
          ledgerByParty: action.payload || [],
          loading: false,
          error: null
      }
    }
    case SET_LEDGER_BY_SCHEDULE: {
      return {
        ...state,
          ledgerBySchedule: action.payload || [],
          loading: false,
          error: null
      }
    }
    case LEDGER_BY_PARTY_REPORT_FAILURE: {
      return {
        ...state,
        ledgerByParty: {},
        loading: false,
        error: action.error
      };
    }
    case LEDGER_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case LEDGER_REPORT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case LEDGER_REPORT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default ledgerReportReducer;
